var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tasks-table',{attrs:{"project_id":Number(_vm.$route.params.id),"from":'Projects Task',"showProject":'true',"task_link":'project-tasks-show-general'}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }